import React, { useEffect, useRef } from 'react';
import './CancelPendingCancellationModal.css';

function CancelPendingCancellationModal({ isOpen, onConfirm, onCancel }) {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onCancel();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onCancel]);

  useEffect(() => {
    if (isOpen && modalRef.current) {
      modalRef.current.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onCancel();
    }
  };

  return (
    <div 
      className="overlay" 
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div 
        ref={modalRef}
        className="cancelPendingCancellationModal"
        tabIndex="-1"
      >
        <h2 id="modal-title">Cancel Pending Cancellation?</h2>
        <p>
          Are you sure you want to undo your membership cancellation? Your recurring payments will continue as scheduled.
        </p>
        <button 
          onClick={onConfirm} 
          className="cancelPendingCancellationConfirmButton"
          aria-label="Confirm cancellation reversal"
        >
          Yes, Undo Cancellation
        </button>
        <button 
          onClick={onCancel} 
          className="cancelPendingCancellationCancelButton"
          aria-label="Keep cancellation"
        >
          No, Keep Cancellation
        </button>
        <button 
          className="cancelPendingCancellationModalCloseButton" 
          onClick={onCancel}
          aria-label="Close modal"
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default CancelPendingCancellationModal;
